import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/sunrunTheme.styles';

type ArticleInfoProps = {
  publicationDate: string;
  readingTime: number;
  classname?: string;
  textColor?: string;
};

const ArticleInfo = ({
  publicationDate,
  readingTime,
  classname,
  textColor = brandColors.tintsNeutral20,
}: ArticleInfoProps) => {
  const { classes: globalClasses, cx } = useGlobalStyles({ fixed: true });
  const parsedDate = Date.parse(publicationDate);
  let formattedDate = 'Invalid date';

  if (!isNaN(parsedDate)) {
    formattedDate = new Intl.DateTimeFormat('en-US', {
      timeZone: 'UTC', // setting timezone to 'UTC' will not perform local conversions
    }).format(parsedDate);
  }

  return (
    <span
      className={cx(globalClasses.body, classname)}
      style={{ color: textColor }}
    >{`${formattedDate} | ${readingTime} min read`}</span>
  );
};

export default ArticleInfo;
